<template>
	<table class="labels-table">
		<thead>
			<tr>
				<th><input type="checkbox" class="labels-table__checkbox" /></th>
				<th>Internal-ID</th>
				<th>External-ID</th>
				<th>Date / Time</th>
				<th>Customer Name</th>
				<th>Address</th>
				<th>City</th>
				<th>State</th>
				<th>C-Code</th>
				<th>Details / PDFs</th>
			</tr>
		</thead>
	</table>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "LabelsTable",
	components: {}
});
</script>

<style lang="scss" scoped>
.labels-table {
	margin-bottom: 15px;
	table-layout: fixed;
	
	//
	&__checkbox {
		transform: translate(-50%, -50%);
		position: absolute;

		height: 17px;
		width: 17px;

		left: 55%;
		top: 50%;
	}

	th {
		border: 1px solid $border-color;
		background-color: $color8;
		height: 30px;

		text-transform: uppercase;
		text-align: center;
		font-weight: 700;
		font-size: 11px;
		
	}
	th:nth-child(1) {
		position: relative;
		width: 30px;
	}
	th:nth-child(2) {
		width: 100px;
	}
	th:nth-child(3) {
		width: 91px;
	}
	th:nth-child(4) {
		width: 130px;
	}
	th:nth-child(5) {
		width: 215px;
	}
	th:nth-child(6) {
		width: 286px;
	}
	th:nth-child(7) {
		width: 185px;
	}
	th:nth-child(8) {
		width: 122px;
	}
	th:nth-child(9) {
		width: 70px;
	}
	th:nth-child(10) {
		width: 120px;
	}
}
</style>